<template title="=">
	<div id="body">
		<div class="title">
			<i class="el-icon-s-custom"></i> 企业会员注册
		</div>

		<el-form id="form" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
			<el-form-item label="公司名称" prop="cmpName">
				<el-input v-model.trim="ruleForm.cmpName" @blur="isCompany" placeholder="请输入公司名称"></el-input>
			</el-form-item>
			<el-form-item label="手机号码" prop="phone">
				<el-input type="tel" v-model.trim="ruleForm.phone" placeholder="请输入手机号码"></el-input>
			</el-form-item>
			<el-form-item label="验证码" prop="VCode" style="width: 225px;" id="yzm">
				<el-input type="tel" v-model.trim="ruleForm.VCode" placeholder="请输入验证码"></el-input>
				<el-button type="primary" v-show="show" @click="getCode" class="yzm">获取验证码</el-button>
				<el-button type="primary" v-show="!show" class="count yzm">{{count}}s后重发</el-button>
			</el-form-item>
			<el-form-item label="所在城市" prop="city">
				<el-input v-model.trim="ruleForm.city" placeholder="请输入所在城市"></el-input>
			</el-form-item>
			<el-form-item label="密码" prop="pass">
				<el-input type="tel" style="-webkit-text-security: square" v-model.trim="ruleForm.pass"
					onkeyup="this.value = this.value.replace(/[^\d.]/g,'');" minlength="6" maxlength="6"
					placeholder="请输入六位数字密码"></el-input>
			</el-form-item>
			<el-form-item label="确认密码" prop="checkPass">
				<el-input type="tel" style="-webkit-text-security: square" v-model.trim="ruleForm.checkPass"
					onkeyup="this.value = this.value.replace(/[^\d.]/g,'');" minlength="6" maxlength="6"
					placeholder="请再次输入六位数字密码">
				</el-input>
			</el-form-item>
			<div v-if="this.company">
				<el-form-item label="公司地址" prop="cmpAddress">
					<el-input v-model.trim="ruleForm.cmpAddress" placeholder="请输入公司地址"></el-input>
				</el-form-item>
				<el-form-item label="信用代码" prop="creditCode">
					<el-input v-model.trim="ruleForm.creditCode" placeholder="请输入统一社会信用代码" clearable></el-input>
				</el-form-item>
				<el-form-item label="营业执照" prop="businessLicense">
					<el-upload class="avatar-uploader" :action="this.$store.state.upload" :show-file-list="false"
						:headers="headers" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"
						v-loading="loading">
						<img v-if="ruleForm.businessLicense" :src="ruleForm.businessLicense"
							v-model="ruleForm.businessLicense" class="avatar" style="height: 100%; width: 100%;">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>
			</div>
			<el-form-item style="margin-left: -80px;">
				<el-button type="primary" @click="submitForm('ruleForm')" class="register">立即注册</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	export default {
		name: 'enterprise',
		data() {
			var validatePass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入密码'));
				} else {
					if (this.ruleForm.checkPass !== '') {
						this.$refs.ruleForm.validateField('checkPass');
					}
					callback();
				}
			};
			var validatePass2 = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请再次输入密码'));
				} else if (value !== this.ruleForm.pass) {
					callback(new Error('两次输入密码不一致!'));
				} else {
					callback();
				}
			};
			return {
				loading: false,
				//验证码
				count: '',
				headers: {
					"openId": localStorage.getItem('openId'),
					"thirdsession": this.$Cookies.get('thirdsession')
				},
				show: true,
				timer: null,
				company: true, //如果公司存在就隐藏公司表单信息
				ruleForm: {
					//用户信息
					phone: '',
					VCode: '',
					pass: '',
					checkPass: '',
					cmpId: '',
					openId: '',
					type: 0,
					//公司信息
					cmpName: '',
					city: '',
					cmpAddress: '',
					creditCode: '',
					businessLicense: '',
				},
				rules: {
					phone: [{
							required: true,
							message: '请输入手机号码',
							trigger: 'blur'
						},
						{
							min: 10,
							max: 11,
							message: '请输入11位的手机号码',
							trigger: 'blur'
						}
					],
					VCode: [{
							required: true,
							message: '请输入验证码',
							trigger: 'blur'
						},
						{
							min: 4,
							max: 4,
							message: '请输入4位的验证码',
							trigger: 'blur'
						}
					],
					pass: [{
						required: true,
						validator: validatePass,
						trigger: 'blur'
					}, {
						min: 6,
						max: 6,
						message: '请输入六位数字密码',
						trigger: 'blur'
					}],
					checkPass: [{
						required: true,
						validator: validatePass2,
						trigger: 'blur'
					}, {
						min: 6,
						max: 6,
						message: '请输入六位数字密码',
						trigger: 'blur'
					}],
					creditCode: [{
							required: true,
							message: '请输入社会统一信用代码',
							trigger: 'blur'
						},
						{
							min: 18,
							max: 18,
							message: '请输入正确的社会统一信用代码',
							trigger: 'blur'
						}
					],
					cmpAddress: [{
						required: true,
						message: '请输入公司地址',
						trigger: 'blur'
					}],
					cmpName: [{
						required: true,
						message: '请输入公司名称',
						trigger: 'blur'
					}],
					city: [{
						required: true,
						message: '请输入所在城市',
						trigger: 'blur'
					}],
					businessLicense: [{
						required: true,
						message: "请上传营业执照",
						trigger: "blur",
					}],
				}
			};
		},
		methods: {
			//判断公司是否存在，存在则隐藏公司信息并把公司id放入表单内
			isCompany() {
				this.$api({
					method: 'post',
					url: '/mobileLogin/isCompany',
					params: {
						"cmpName": this.ruleForm.cmpName
					}
				}).then((res) => {
					if (res.data.data.isDel != 3) {
						this.$message.success(res.data.msg)
						this.company = false
						this.ruleForm.cmpId = res.data.data.cmpId
					} else {
						this.company = true
					}
				});
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						//判断输入的验证码和后端返回的是否一致，一致则提交表单
						this.$api({
							method: 'post',
							url: '/mobileLogin/register',
							params: {
								phone: this.ruleForm.phone,
								checkPass: this.ruleForm.checkPass,
								cmpId: this.ruleForm.cmpId,
								openId: this.ruleForm.openId,
								cmpName: this.ruleForm.cmpName,
								city: this.ruleForm.city,
								cmpAddress: this.ruleForm.cmpAddress,
								creditCode: this.ruleForm.creditCode,
								businessLicense: this.ruleForm.businessLicense,
								VCode: this.ruleForm.VCode,
								type: this.ruleForm.type
							}
						}).then((res) => {
							if (res.data.code == '200') {
								this.$router.push('/success?text=' + res.data.msg);
							} else {
								this.ruleForm.checkPass = ''
								this.$notify.error({
									title: res.data.msg,
									showClose: false,
									duration: 5000
								});
							}
						});
					}
				});
			},
			handleAvatarSuccess(res, file) {
				this.ruleForm.businessLicense = this.$store.state.showUpload + res.url
				this.loading = false
			},
			beforeAvatarUpload(file) {
				const isLt30M = file.size / 1024 / 1024 < 30;
				if (!isLt30M) {
					this.$message.error('上传图片大小不能超过 30MB!');
					this.loading = false
				} else {
					this.loading = true
					return isLt30M;
				}

			},
			//获取验证码
			getCode() {
				if (this.ruleForm.phone != '') {
					this.$api({
						method: 'get',
						url: '/mobileLogin/sms?phone=' + this.ruleForm.phone
					}).then((res) => {
						console.log(res.data)
					});
					const TIME_COUNT = 60;
					if (!this.timer) {
						this.count = TIME_COUNT;
						this.show = false;
						this.timer = setInterval(() => {
							if (this.count > 0 && this.count <= TIME_COUNT) {
								this.count--;
							} else {
								this.show = true;
								clearInterval(this.timer);
								this.timer = null;
							}
						}, 1000)
					}
				} else {
					this.$notify.error({
						title: '请先填写手机号码',
						showClose: false,
						duration: 5000
					});
				}

			},
		},
		created() {
			this.ruleForm.openId = localStorage.getItem('openId')
		},

	}
</script>

<style scoped="scoped">
	.title {
		margin-bottom: 0.5rem;
	}

	.yzm {
		position: absolute;
		float: right;
		margin-left: 5px;
		width: 85%;
	}

	.demo-ruleForm {
		width: 95%;
		padding-right: 5%;
		margin: 0 auto;
	}

	#upload {
		width: 100%;
	}

	.register {
		width: 100%;
		margin-bottom: 20px;
	}

	#form {
		padding-top: 10px;
		background-color: #FFFFFF;
	}

	/* 上传图片 */
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 18px;
		color: #8c939d;
		height: 3px;
		margin-top: -31%;
		text-align: center;
	}

	.avatar {
		display: block;
	}
</style>
